import React from 'react';
import { ChildSupportContent } from './ChildSupportContent';

export const MobileCSContent = ({ packageName, styles }) => {
  let price = '1000грн';

  switch (packageName) {
    case 'min':
      price = '1000грн';
      break;
    case 'mid':
      price = '2000грн';
      break;
    case 'max':
      price = '3500грн';
      break;
    default:
      console.error('Wrong package name');
  }

  return (
    <div className="mobile-cs-content" style={styles}>
      <ChildSupportContent packageName={packageName} />
      <div className="mobile-cs-content-price">{price}</div>
    </div>
  );
};
